// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import GtmController from "./gtm_controller.js"
application.register("gtm", GtmController)

import FancyboxController from "./fancybox_controller.js"
application.register("fancybox", FancyboxController)

import CollapseController from "./collapse_controller.js"
application.register("collapse", CollapseController)

import ImageSwitcherController from "./image_switcher_controller.js"
application.register("image-switcher", ImageSwitcherController)
